import { type AxiosRequestConfig } from 'axios'

const verifyEmail = (token: string): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/auth/verify-email',
    data: {
      token,
    },
  }
}

export { verifyEmail }
